import {
  FILTER_RECORDING_VIEWS,
  GET_RECORDING_DETAILS_FAILURE,
  GET_RECORDING_DETAILS_REQUEST,
  GET_RECORDING_DETAILS_SUCCESS
} from './RecordingDetailsActions';
import moment from 'moment-timezone';
import { divideSafe } from '../../Utils/MathUtils';
const initialState = {
  fetching: false,
  recordingDetails: {
    name: null,
    datePublished: null,
    videoLengthInMillis: null,
    size: null,
    recordingSource: null
  },
  g2wViews: [],
  g2sViews: [],
  g2sEmbeddedViews: [],
  filteredG2WViews: [],
  filteredG2SViews: [],
  filteredG2SEmbeddedViews: [],
  stats: {
    totalViewCount: 0,
    g2wViewCount: 0,
    g2sViewCount: 0,
    g2sEmbeddedViewCount: 0,
    g2wViewerCount: 0,
    g2sViewerCount: 0,
    g2sEmbeddedViewerCount: 0,
    g2sTotalWatchTimeInMillis: 0,
    g2sAverageWatchTimeInMillis: 0,
    g2sAveragePercentageViewed: 0,
    g2sWatchTimeInPercentSum: 0
  },
  filter: {
    fromTime: null,
    toTime: null,
    searchString: ''
  },
  error: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_RECORDING_DETAILS_REQUEST: {
      return { ...state, ...initialState, fetching: true };
    }
    case GET_RECORDING_DETAILS_SUCCESS: {
      const { recordingDetails, g2wViews, g2sViews, g2sEmbeddedViews, filter } = action.payload;
      const { filteredG2WViews, filteredG2SViews, filteredG2SEmbeddedViews } = filterViewers(
        filter,
        g2wViews,
        g2sViews,
        g2sEmbeddedViews
      );
      return {
        ...state,
        recordingDetails,
        g2wViews,
        g2sViews,
        g2sEmbeddedViews,
        filter: { ...state.filter, ...filter },
        filteredG2WViews,
        filteredG2SViews,
        filteredG2SEmbeddedViews,
        stats: calculateStats(g2wViews, g2sViews, g2sEmbeddedViews),
        fetching: false
      };
    }
    case GET_RECORDING_DETAILS_FAILURE: {
      return { ...state, error: action.error, fetching: false };
    }
    case FILTER_RECORDING_VIEWS: {
      const {
        fromTime = state.filter.fromTime,
        toTime = state.filter.toTime,
        searchString = state.filter.searchString
      } = action.payload;
      const newFilter = { fromTime, toTime, searchString };
      const { filteredG2WViews, filteredG2SViews, filteredG2SEmbeddedViews } = filterViewers(
        newFilter,
        state.g2wViews,
        state.g2sViews,
        state.g2sEmbeddedViews
      );

      return {
        ...state,
        filteredG2WViews,
        filteredG2SViews,
        filteredG2SEmbeddedViews,
        filter: newFilter,
        stats: calculateStats(filteredG2WViews, filteredG2SViews, filteredG2SEmbeddedViews)
      };
    }
    default:
      return state;
  }
};

function calculateStats(g2wViews = [], g2sViews = [], g2sEmbeddedViews = []) {
  const g2wEmails = new Set();
  const g2sEmails = new Set();
  const g2sEmbeddedEmails = new Set();
  let g2wStats = g2wViews.reduce((accumulatedStats, currentView) => {
    g2wEmails.add(currentView.email);
    return {
      ...accumulatedStats,
      totalViewCount: accumulatedStats.totalViewCount + currentView.viewCount,
      g2wViewCount: accumulatedStats.g2wViewCount + currentView.viewCount
    };
  }, initialState.stats);

  let combinedStats = g2sViews.reduce((accumulatedStats, currentView) => {
    let viewDurationInMillis = 0;
    let watchTimeInPercent = 0;

    if (!g2sEmails.has(currentView.email)) {
      viewDurationInMillis = currentView.viewDurationInMillis;
      watchTimeInPercent = currentView.watchTimeInPercent;
      g2sEmails.add(currentView.email);
    }

    return {
      ...accumulatedStats,
      totalViewCount: accumulatedStats.totalViewCount + currentView.viewCount,
      g2sViewCount: accumulatedStats.g2sViewCount + currentView.viewCount,
      g2sTotalWatchTimeInMillis: accumulatedStats.g2sTotalWatchTimeInMillis + viewDurationInMillis,
      g2sWatchTimeInPercentSum: accumulatedStats.g2sWatchTimeInPercentSum + watchTimeInPercent
    };
  }, g2wStats);

  const g2sAverageWatchTimeInMillis = divideSafe(combinedStats.g2sTotalWatchTimeInMillis, g2sEmails.size).toFixed(2);
  const g2sAveragePercentageViewed = divideSafe(combinedStats.g2sWatchTimeInPercentSum, g2sEmails.size).toFixed(2);

  combinedStats = g2sEmbeddedViews.reduce((acc, curr) => {
    g2sEmbeddedEmails.add(curr.email);
    return {
      ...acc,
      totalViewCount: acc.totalViewCount + curr.viewCount,
      g2sEmbeddedViewCount: acc.g2sEmbeddedViewCount + curr.viewCount
    };
  }, combinedStats);
  return {
    ...combinedStats,
    g2sAverageWatchTimeInMillis,
    g2sAveragePercentageViewed,
    g2wViewerCount: g2wEmails.size,
    g2sViewerCount: g2sEmails.size,
    g2sEmbeddedViewerCount: g2sEmbeddedEmails.size
  };
}

function filterViewers(filter, g2wViews = [], g2sViews = [], g2sEmbeddedViews = []) {
  const filterFunc = function(view) {
    const { fromTime, toTime, searchString } = filter;
    const { viewDate, givenName = '', surName = '', email = '' } = view;

    return (
      moment(viewDate).isBetween(fromTime, toTime) &&
      (searchString && (givenName || surName || email)
        ? [givenName, surName, email].some(n => n.toUpperCase().includes(searchString.toUpperCase()))
        : true)
    );
  };

  const filteredG2WViews = g2wViews.filter(filterFunc);
  const filteredG2SViews = g2sViews.filter(filterFunc);
  const filteredG2SEmbeddedViews = g2sEmbeddedViews.filter(filterFunc);
  return { filteredG2WViews, filteredG2SViews, filteredG2SEmbeddedViews };
}



// WEBPACK FOOTER //
// ./src/Reducks/RecordingDetails/RecordingDetailsReducer.js